import React from "react";

const StayoverButton = ({ text, onClick, size }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-1 rounded-full text-nowrap bg-[#fca400] text-white ${
        size === "sm" ? "text-xs" : "text-sm"
      } scale-100 hover:scale-105 transition-all duration-300`}
    >
      {text}
    </button>
  );
};

export default StayoverButton;
